import React, { useState, useEffect } from 'react';
import { Container, Table, Badge, Spinner, Alert, Card, Row, Col, Accordion } from 'react-bootstrap';
import axios from 'axios';
import { ApiUrl, Headers } from '../services/ApiUrl';

const VotosEnBlanco = () => {
    const [votosBlanco, setVotosBlanco] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        cargarVotosEnBlanco();
    }, []);

    const cargarVotosEnBlanco = async () => {
        setLoading(true);
        setError(null);
        try {
            const url = `${ApiUrl}getvotosblanco`;
            const response = await axios.get(url, { headers: Headers });
            
            if (response.data.error === false) {
                setVotosBlanco(response.data.votos);
            } else {
                setError(response.data.mensaje);
            }
        } catch (error) {
            setError('Error al cargar los datos: ' + error.message);
        } finally {
            setLoading(false);
        }
    };

    const calcularTotales = () => {
        const totalDNIs = votosBlanco.length;
        const totalRegistros = votosBlanco.reduce((acc, voto) => 
            acc + parseInt(voto.cantidad_registros || 0), 0);
        const dnisDuplicados = votosBlanco.filter(voto => 
            parseInt(voto.cantidad_registros || 0) > 1).length;

        return { totalDNIs, totalRegistros, dnisDuplicados };
    };

    const splitSafely = (str) => {
        if (!str) return [];
        return str.split(',');
    };

    const hanPasado24Horas = (fechaStr) => {
        if (!fechaStr) return false;
        const fecha = new Date(fechaStr);
        const ahora = new Date();
        const diferencia = ahora - fecha;
        const horas = diferencia / (1000 * 60 * 60);
        return horas >= 24;
    };

    const formatearFecha = (fechaStr) => {
        if (!fechaStr) return '-';
        try {
            const fecha = new Date(fechaStr);
            return fecha.toLocaleDateString('es-AR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        } catch (e) {
            return fechaStr;
        }
    };

    const contenidoVotosEnBlanco = () => {
        if (loading) {
            return (
                <div className="text-center">
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Cargando...</span>
                    </Spinner>
                    <p>Cargando votos en blanco...</p>
                </div>
            );
        }

        if (error) {
            return (
                <Alert variant="danger">
                    {error}
                </Alert>
            );
        }

        const { totalDNIs, totalRegistros, dnisDuplicados } = calcularTotales();

        return (
            <>
                <Row className="mb-4">
                    <Col md={4}>
                        <Card className="text-center h-100">
                            <Card.Body>
                                <Card.Title>Total DNIs Únicos</Card.Title>
                                <h3 className="text-primary">{totalDNIs}</h3>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={4}>
                        <Card className="text-center h-100">
                            <Card.Body>
                                <Card.Title>Total Registros</Card.Title>
                                <h3 className="text-success">{totalRegistros}</h3>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={4}>
                        <Card className="text-center h-100">
                            <Card.Body>
                                <Card.Title>DNIs con Duplicados</Card.Title>
                                <h3 className="text-warning">{dnisDuplicados}</h3>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Table responsive striped bordered hover>
                    <thead>
                        <tr>
                            <th>DNI</th>
                            <th>Nombre(s)</th>
                            <th>Email(s)</th>
                            <th>Fecha(s)</th>
                            <th>Cantidad</th>
                            <th>IDs de Votante</th>
                        </tr>
                    </thead>
                    <tbody>
                        {votosBlanco.map((voto, index) => (
                            <tr key={index}>
                                <td>{voto.dni || '-'}</td>
                                <td>
                                    {splitSafely(voto.nombres).map((nombre, i) => (
                                        <div key={i}>{nombre || '-'}</div>
                                    ))}
                                </td>
                                <td>
                                    {splitSafely(voto.mails).map((mail, i) => (
                                        <div key={i}>{mail || '-'}</div>
                                    ))}
                                </td>
                                <td>
                                    {splitSafely(voto.fechas).map((fecha, i) => (
                                        <div 
                                            key={i}
                                            style={{
                                                backgroundColor: hanPasado24Horas(fecha) ? '#fff3cd' : 'transparent',
                                                padding: '2px 5px',
                                                borderRadius: '3px'
                                            }}
                                        >
                                            {formatearFecha(fecha)}
                                        </div>
                                    ))}
                                </td>
                                <td className="text-center">
                                    <Badge bg={parseInt(voto.cantidad_registros || 0) > 1 ? "warning" : "success"}>
                                        {voto.cantidad_registros || 0}
                                    </Badge>
                                </td>
                                <td>
                                    {splitSafely(voto.ids_votante).map((id, i) => (
                                        <Badge key={i} bg="info" className="me-1">
                                            {id || '-'}
                                        </Badge>
                                    ))}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
                {votosBlanco.length === 0 && (
                    <Alert variant="info">
                        No hay votos en blanco registrados.
                    </Alert>
                )}
            </>
        );
    };

    return (
        <Container className="mt-4">
            <Accordion>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>
                        <i className="bi bi-list-check me-2"></i>
                        Votos en Blanco
                    </Accordion.Header>
                    <Accordion.Body>
                        {contenidoVotosEnBlanco()}
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </Container>
    );
};

export default VotosEnBlanco;